import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import StatsCard from "../../AdminPanel/Component/UI/StatsCard";
import SelectOption from "../../AdminPanel/Component/UI/SelectOption";
import Loader from "../../AdminPanel/Component/UI/Loader";
import { LuUsers, LuUserCheck, LuDownload } from "react-icons/lu";
import { SlReload } from "react-icons/sl";
import { MdArrowForwardIos } from "react-icons/md";
import Heading from "../../AdminPanel/Component/UI/Heading";
import ViewButton from "../../AdminPanel/Component/UI/ViewButton";
import TriangleChart from "./Charts/TriangleChart";
import moment from 'moment';
import { HiOutlineDocumentReport } from "react-icons/hi";
import { FaPlay } from "react-icons/fa";
import ProgressTab from "../Component/ProgressTab";


class Overview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      crrTeamId: localStorage.getItem("crrTeamId") || ""
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    const { crrTeamId } = this.state;
    const temp2 = {
      keyWord: "",
      pageNo: 1,
      size: 100000
    }
    this.props.dispatch(assessmentActions.getCompletedTeamList(temp2, "report", crrTeamId));
  }

  onAssessmentSummary = (type) => {
    if (type === 1) {
      this.props.history.push(`/assessment/dashboard`);
    } else if (type === 2) {
      this.props.history.push(`/assessment/myreport`);
    } else if (type === 3) {
      this.props.history.push(`/assessment/myvideos`);
    }

  }

  handleTeamChange = (value) => {
    localStorage.setItem("crrTeamId", value);
    this.setState({ crrTeamId: value }, () => {
      const paginationData = {
        "teamId": value,
        "isAll": true
      }
      this.props.dispatch(assessmentActions.getAssessmentReportByTeamId(paginationData));
    });
  };


  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };


  render() {
    let { crrTeamId } = this.state;
    const { assessment } = this.props;
    const { getAssessmentReportByTeamIdData, userAssessmentUserProfileData,
      getCompletedTeamListData } = assessment;

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }
    const assessments =
      Array.isArray(getAssessmentReportByTeamIdData) && getAssessmentReportByTeamIdData.length > 0
        ? getAssessmentReportByTeamIdData
          .slice(0, 5)
          .map((ele, index) => ({
            id: index + 1,
            label: ele?.dimension ?? "",
            color: ele?.colorCode ?? "",
          }))
        : [];
    const teamNameListData = getCompletedTeamListData && getCompletedTeamListData.length > 0 ? getCompletedTeamListData.map((ele) => ({ value: ele.id, label: ele.name })) : [];

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };


    const crrInitTeamId = crrTeamId || teamNameListData?.[0]?.value || "";
    let { loading } = assessment;
    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="p-8">

          <ProgressTab currentStep={4} history={this.props.history} />
          <div className="border-b border-slate-300" />


          {false && <div className="space-y-5">
            <div className="flex justify-between items-center">
              <Heading className="text-2xl font-bold text-gray-900" title="Overview" />

              <div className="w-64">
                <SelectOption
                  name="teamId"
                  value={crrInitTeamId}
                  onChange={(e) => this.handleTeamChange(e.target.value)}
                  placeholder="Select Team"
                  options={teamNameListData}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <StatsCard icon={LuUsers} label="Users Left" value="2" />
              <StatsCard icon={LuUserCheck} label="Users Completed" value="27" />
              <StatsCard icon={SlReload} label="Users Pending" value="27" />
            </div>
          </div>
          }
          {false &&
            <div className="mb-10">
              {/* Header */}
              <div className="flex justify-between items-center pb-3">
                <Heading className="text-xl" title="Team Executive Snapshot" />
                <ViewButton onClick={() => this.onAssessmentSummary(1)} title="View All" Icon={MdArrowForwardIos} />
              </div>
              {/* Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Talent Snapshot */}
                {assessments && assessments.length > 0 &&
                  <div className="bg-white border border-[#D1D5DB] rounded-xl p-6">
                    <Heading className="text-xl" title="Your Talent Snapshot" />
                    <p className="text-sm textlight my-2">Based on your most recent assessment, your top 5 talent themes.</p>
                    <p className="text-xs font-medium italic textblack mb-6">Last assessed: Apr 15, 2024</p>
                    <div className="grid grid-cols-2 gap-6 items-center">
                      <TriangleChart colors={assessments.map((ele) => (ele.color))} />
                      <div className="space-y-2 text-sm">
                        {assessments.map((ele) => (
                          <p key={ele.id} className="flex items-center">
                            <span style={{ borderColor: hexToRgbA(ele.color, "100") }}
                              className="inline-block h-10 border-l-2 px-1">
                            </span>
                            <span className="font-medium textblack">{ele.id + ". " + ele.label}</span>
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>}
              </div>
            </div>}

          {/* Assessment Section */}
          <div className="mb-10 space-y-9">
            <div className="flex justify-between items-center pt-5">
              <Heading className="text-2xl font-bold text-gray-900" title="Talent Insight" />

              <div className="w-64">
                <SelectOption
                  name="teamId"
                  value={crrTeamId}
                  onChange={(e) => this.handleTeamChange(e.target.value)}
                  placeholder="Select Team"
                  options={teamNameListData}
                />
              </div>
            </div>
            {assessments && assessments.length > 0 ?
              <>
                <div className="grid grid-cols-3 gap-6">

                  {/* Summary Card */}
                  <div className="bg-white border border-[#D1D5DB] rounded-lg p-6 flex flex-col h-full hover:shadow-lg">
                    <div>
                      <ul className="space-y-2 mb-4">
                        {assessments && assessments.length > 0 && assessments.map((ele) => (
                          <li
                            key={ele.id}
                            className="flex items-center gap-3 px-3 py-3 rounded"
                            style={{ background: hexToRgbA(ele.color, "0.20") }}
                          >
                            <span
                              style={{ background: hexToRgbA(ele.color, "0.70") }}
                              className="w-6 h-6 rounded-full text-white text-xs flex items-center justify-center font-bold"
                            >
                              {ele.id}
                            </span>
                            <span className="text-sm font-medium">{ele.label}</span>
                          </li>
                        ))}
                      </ul>

                      <Heading className="text-xl" title="Summary" />
                      <p className="text-sm textlight my-3">
                        Your Dominant themes are the core qualities that define who you are and contribute to your success.
                      </p>
                    </div>

                    <div className="mt-auto pt-4">
                      <button
                        onClick={() => this.onAssessmentSummary(1)}
                        className="border border-[#1976D2] textcolor px-4 py-2 rounded-md w-full
             flex items-center justify-center gap-2 hover:bg-gradient-to-r from-[#673AB7] to-[#1976D2] hover:text-white"
                      >
                        View Summary
                        <MdArrowForwardIos className="text-sm" />
                      </button>
                    </div>
                  </div>

                  {/* Report Card */}
                  <div className="bg-white border border-[#D1D5DB] rounded-lg p-6 flex flex-col h-full hover:shadow-lg">
                    <div>
                      <img src="/img/dashboardhr/report.png" alt="report" className="rounded-md mb-4 w-full" />
                      <Heading className="text-xl" title="Report" />
                      <p className="text-sm textlight my-3">
                        Your Dominant themes are the core qualities that define who you are and contribute to your success.
                      </p>
                    </div>

                    <div className="mt-auto pt-4">
                      <button
                        onClick={() => this.onAssessmentSummary(2)}
                        className="border border-[#1976D2] textcolor px-4 py-2 rounded-md w-full flex items-center justify-center gap-2 hover:bg-gradient-to-r from-[#673AB7] to-[#1976D2] hover:text-white">
                        View Report
                        <HiOutlineDocumentReport className="text-lg" />
                      </button>
                    </div>
                  </div>

                  {/* Video Card */}
                  <div className="bg-white border border-[#D1D5DB] rounded-lg p-6 flex flex-col h-full hover:shadow-lg">
                    <div>
                      <div className="relative mb-4">
                        <img src="/img/dashboardhr/video.png" alt="video" className="rounded-md w-full" />
                        <span className="absolute inset-0 flex items-center justify-center text-white text-3xl">
                          ▶
                        </span>
                      </div>

                      <Heading className="text-xl" title="Assessment Video" />
                      <p className="text-sm textlight my-3">
                        Your Dominant themes are the core qualities that define who you are and contribute to your success.
                      </p>
                    </div>

                    <div className="mt-auto pt-4">
                      <button
                        onClick={() => this.onAssessmentSummary(3)}
                        className="border border-[#1976D2] textcolor px-4 py-2 rounded-md w-full
             flex items-center justify-center gap-2 hover:bg-gradient-to-r from-[#673AB7] to-[#1976D2] hover:text-white"
                      >
                        Watch Video
                        <FaPlay className="text-sm" />
                      </button>
                    </div>
                  </div>

                </div>
              </>
              :
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {[1, 2, 3].map(() =>
                    <div className="bg-white border border-dashed border-[#D1D5DB] rounded-xl p-6 flex flex-col items-center justify-center text-center min-h-[260px]">
                      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-7 w-7 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 17v-2a4 4 0 014-4h2M9 5h6m2 0a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h10z"
                          />
                        </svg>
                      </div>

                      <p className="text-base font-semibold textblack mb-1">
                        Data not available
                      </p>
                      <p className="text-sm textlight max-w-xs">
                        No assessment data has been recorded yet. Once assessments are completed,
                        your talent snapshot will appear here.
                      </p>
                    </div>
                  )}
                </div>
              </>}

          </div>
        </div>

      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}
export default connect(mapStateToProps)(Overview);
